import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-accent-500 text-background-50 rounded-lg">
                <i className="ri-book-read-line text-lg"></i>
              </span>
              <span className="text-lg font-semibold font-heading text-foreground-950">韩国伦理网</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              深度解析韩国社会道德与价值观，全面探讨韩国伦理的核心内涵，帮助您系统理解韩国伦理的独特体系与当代意义。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">内容分类</h4>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-accent-600 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速链接</h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors duration-200">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors duration-200">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors duration-200">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">关注我们</h4>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-accent-100 hover:text-accent-600 transition-colors duration-200 cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-accent-100 hover:text-accent-600 transition-colors duration-200 cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-accent-100 hover:text-accent-600 transition-colors duration-200 cursor-pointer" aria-label="邮件" rel="nofollow">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
            <p className="mt-4 text-sm text-foreground-500">
              邮箱：contact@korean-ethics.com
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩国伦理网. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-600 transition-colors duration-200" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-600 transition-colors duration-200" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}